// extracted by mini-css-extract-plugin
export default {"main":"TaxiFlyerPage_main__vYEo7","flyer-container":"TaxiFlyerPage_flyer-container__pG-Zi"};